import { Col, Form, Input, Row } from 'ui';

export type JoinedProgramsListFiltersFormValues = {
  search?: string;
};

const JoinedProgramsListFilters = () => (
  <Row gutter="ms">
    <Col flex="1">
      <Form.Item<JoinedProgramsListFiltersFormValues> label="Search" name="search">
        <Input hasSearch />
      </Form.Item>
    </Col>
  </Row>
);

export default JoinedProgramsListFilters;
